var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_998_1190)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3653 7.40738C18.5528 7.59491 18.6581 7.84921 18.6581 8.11438C18.6581 8.37954 18.5528 8.63385 18.3653 8.82138L10.87 16.3167C10.7709 16.4158 10.6533 16.4944 10.5239 16.548C10.3945 16.6016 10.2558 16.6292 10.1157 16.6292C9.97556 16.6292 9.83683 16.6016 9.7074 16.548C9.57797 16.4944 9.46037 16.4158 9.36132 16.3167L5.63732 12.5934C5.54181 12.5011 5.46563 12.3908 5.41322 12.2688C5.36081 12.1468 5.33322 12.0156 5.33207 11.8828C5.33092 11.75 5.35622 11.6183 5.4065 11.4954C5.45678 11.3725 5.53103 11.2609 5.62492 11.167C5.71882 11.0731 5.83047 10.9988 5.95337 10.9486C6.07626 10.8983 6.20794 10.873 6.34072 10.8741C6.4735 10.8753 6.60472 10.9029 6.72672 10.9553C6.84873 11.0077 6.95907 11.0839 7.05132 11.1794L10.1153 14.2434L16.9507 7.40738C17.0435 7.31445 17.1538 7.24073 17.2752 7.19044C17.3965 7.14014 17.5266 7.11426 17.658 7.11426C17.7894 7.11426 17.9195 7.14014 18.0408 7.19044C18.1622 7.24073 18.2725 7.31445 18.3653 7.40738Z",
    fill: "#F1F1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_998_1190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkDark);
export default __webpack_public_path__ + "static/media/icon-checkmark-dark.15e8a31b889e6744428841e6a9731160.svg";
export { ForwardRef as ReactComponent };